import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IProjectElementDetailsInput, IProjectElementsInput, PeerProjectInput, PeerAllElementInput, PeerElementInput, IProjectFeatureInput, IProjectMemberByRoleInput, IProjectMemberByRolesInput } from 'src/app/ViewModel/ProjectElementsModel';
import { CommonService } from '../Common.service';
import { ElementDetailsCacheService } from '../element-details.data.service';
import { RestApiService } from '../rest-api.service';
// import { RestAPIService } from '../rest-api.service';


@Injectable()
export class ProjectInfoService {

  endPoints = {
    getProjectUrl: 'Project/GetProjects',
    getProjectDetailsUrl: 'Project/GetProjectDetails',
    getProjectElements: 'Project/GetProjectElements',
    getProjectElementDetails: 'DEDED/GetDEDAgainstDE',
    getPeerAllElementDetails: 'DEDED/GetAllDEDForPeer',
    getPeerProjectDetails: 'DEDED/GetPeerProjectDetails',
    getProjectFeatureWiseMembers: 'Project/GetProjectFeatureWiseMembers',
    getProjectElementDetailsByDescription: 'Project/GetProjectElementDetailsByDescription',
    getProjectElementIdByDescription: 'Project/GetProjectElementIdByDescription',
    getProjectRoleMembers: 'Project/GetProjectMembersByRole',
    getProjectMemberRoles:'Project/GetProjectsMembersByRoles'
  }

  constructor(private restApiService: RestApiService, private commonService: CommonService, private _elementDetailsCacheService: ElementDetailsCacheService) { }

  /**
   * Get project list by Logged in user id
   * @param userId
   */
  getProjectList(userId: number) {
    let reqData:any = {
      "projectId": null,
      "userId": userId,
    }
    return this.restApiService.new_POST(this.endPoints.getProjectUrl, reqData);
  }

  /**
   * Get Project Details By Project Code
   * @param projectId
   * @param userId
   */
  getProjectDetails(projectId: number, userId: number) {
    let reqData = {
      projectId, userId
    }
   return this.restApiService.new_POST(this.endPoints.getProjectDetailsUrl, reqData);
   
  }

  /**
   * Get project elements with respective to Project Id, Group Id & Module ID
   * @param projEleInput ProjectElementInput
   * @returns
   */
  getProjectElements(projEleInput: IProjectElementsInput) {
    return this.restApiService.new_POST(this.endPoints.getProjectElements, projEleInput);
  }

  /**
 * Get project element details with respective to Project Id, Group Id , Module ID & DE Id
 * @param projEleInput ProjectElementInput
 * @returns
 */
  getProjectElementDetails(projEleDtlInput: IProjectElementDetailsInput) {
    let key: string = projEleDtlInput.moduleId + "_" + projEleDtlInput.deDescription;
    if (this._elementDetailsCacheService.hasElementDetails(key))
      return this._elementDetailsCacheService.getElementDetails(key);
    else
      return this.restApiService.new_POST(this.endPoints.getProjectElementDetails, projEleDtlInput).pipe(map(res => {
        this._elementDetailsCacheService.mapElementDetails(key, res)
        return res;
      }));
  }

  getAllPeerElements(peerallinput: PeerAllElementInput) {
    return this.restApiService.new_POST(this.endPoints.getPeerAllElementDetails, peerallinput);
  }

  getPeerProjectDetails(peerPrjInput: PeerProjectInput) {
    return this.restApiService.new_POST(this.endPoints.getPeerProjectDetails, peerPrjInput);
  }

  getProjectElementCascadingDetails(projEleDtlInput: IProjectElementDetailsInput) {
    return this.restApiService.new_POST(this.endPoints.getProjectElementDetails, projEleDtlInput).pipe(map(res => {
      return res;
    }));
  }

  /**
* Get project Feature wise Members with respective to Project Id, Group Id , Feature Description
* @param projFeatureInput ProjectElementInput
* @returns
*/
  getProjectFeatureWiseMembers(projFeatureInput: IProjectFeatureInput) {

    return this.restApiService.new_POST(this.endPoints.getProjectFeatureWiseMembers, projFeatureInput);
  }

  /**
   * Get element ID by Element Name
   * @param elementName
   * @returns
   */
  getProjectElementIdByDescription(elementName: string) {
    return this.restApiService.new_POST(this.endPoints.getProjectElementIdByDescription, { elementDescription: elementName });
  }

  getProjectMembersByRole(reqData: IProjectMemberByRoleInput) {
    return this.restApiService.new_POST(this.endPoints.getProjectRoleMembers, reqData);
  }


  getProjectMembersByRoles(reqData: IProjectMemberByRolesInput){
    return this.restApiService.new_POST(this.endPoints.getProjectMemberRoles,reqData);
  }
}
